import React, { useState} from "react";
import axios from "axios";
import Loader from "../user/Loader";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { useHistory } from "react-router-dom";


function ResetPassword() {
    const userId = parseInt(localStorage.getItem("id"));
    let history = useHistory();
    const[ passwordStatus, setPasswordStatus ] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [formErrors, setFormErrors] = useState({});
    const [userPassword, setUserPassword] = useState({
        Password:"",
        ConfirmPassword:""
    });

    const handleInputChange = (event) => {
        event.preventDefault();
        setUserPassword({
            ...userPassword, [event.target.name]: event.target.value
        });
    }

    const handlePasswordReset = () => {
        setFormErrors(validateInput(userPassword));
        let formIsValid = validateInput(userPassword).isValidated;
        if(formIsValid){
            setIsLoading(true);
            const data = {
                Password: userPassword.Password
            }
            axios.post(`${process.env.REACT_APP_BASEURL + process.env.REACT_APP_RESET_PASSWORD + userId}`, data)
                .then((response) =>{
                    setIsLoading(false);
                    setPasswordStatus("Successful");
                    setOpen(true);
                })
                .catch((err) =>{
                    setPasswordStatus("Failed");
                    setOpen(true);
                })
        }
    }
       
    
    const validateInput = (element) => {
        let errors = {
            isValidated: true,
            Password: "",
            ConfirmPassword: "",
            PasswordWrongFormat: false
        };
        if (!element.Password) {
            errors.isValidated = false;
            errors.Password = "Input cant't be empty";
        }
        //Minimum eight characters, at least one letter, one number and one special character
        else if (!/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/.test(element.Password)) {
            errors.PasswordWrongFormat = true;
            errors.isValidated = false;
        }
        if (!element.ConfirmPassword) {
            errors.isValidated = false;
            errors.ConfirmPassword = "Input cant't be empty";
        }
        if(element.Password !== element.ConfirmPassword){
            errors.isValidated = false;
            errors.ConfirmPassword = "Password mismatch";
        }
       
        return errors;
    }

    const handleClose = () => {
        setOpen(false);
        history.push("/login");
    }   
    
    return (
        <div className="admin-body">
            <div className="body">
                <div >
                    <div className="password-body-inner-wrapper">
                        <div className="add-user-wrapper">
                            <div className="header-container">
                                <h2>RESET PASSWORD</h2>
                                <hr />
                            </div>
                            <div className="add-user-container">
                                <div>
                                    <input
                                        type="password"
                                        placeholder="Enter Password"
                                        maxLength="30"
                                        className="password"
                                        name="Password"
                                        onChange={handleInputChange}
                                        value={userPassword.Password}
                                    />
                                    {formErrors.Password && <p className="error">{formErrors.Password}</p>}
                                    {formErrors.PasswordWrongFormat && <p className="error">
                                        <ul>
                                            <li>Minimum of 8 characters</li>
                                            <li>At least one letter</li>
                                            <li>At least one number</li>
                                            <li>At least one special character</li>
                                        </ul>
                                    </p>}
                                </div>
                                <div>
                                    <input
                                        type="password"
                                        className="Confirm Password"
                                        name="ConfirmPassword"
                                        placeholder="Confirm Password"
                                        onChange={handleInputChange}
                                    />
                                    {formErrors.ConfirmPassword && <p className="error">{formErrors.ConfirmPassword}</p>}
                                </div>
                                <div>
                                    <button
                                        type="submit"
                                        className="button"
                                        name="submit"
                                        onClick={handlePasswordReset}
                                    >
                                        Reset Password
                                    </button>
                                </div>
                                <Dialog
                                    open={open}
                                    onClose={handleClose}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >
                                    <DialogContent>
                                        <DialogContentText id="alert-dialog-description">
                                            {`Reset ${passwordStatus} !!!`}
                                        </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={handleClose} color="primary">
                                            ok
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Loader state={isLoading} />

        </div>

    )
}
export default ResetPassword;